import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AppProviders } from "./providers/AppProviders";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { IndexRedirect } from "./components/IndexRedirect";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Inventory } from "./pages/Inventory";
import { Clients } from "./pages/Clients";
import { Orders } from "./pages/Orders";
import { ProductionPage } from "./pages/Production";
import { Payments } from "./pages/Payments";
import { Staff } from "./pages/Staff";
import { Settings } from "./pages/Settings";

export const App: React.FC = () => {
  useEffect(() => {
    document.title = "Factory MIS — Dashboard";
  }, []);

  return (
    <AppProviders>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Everything below requires an authenticated session. */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<IndexRedirect />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/production" element={<ProductionPage />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/payments" element={<Payments />} />
              <Route path="/staff" element={<Staff />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AppProviders>
  );
};
